<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            title="政策类别"
            :visible.sync="openData.state"
            width="700px"
            @close="dialogClose"
        >
            <div class="content">
             <el-form label-width="100px" :model="searchData">
                  <el-row :gutter='20'>
                       <el-col :span='12'>
                            <el-form-item label="政策类别：" prop='policyCategoryName'>
                                <el-input placeholder="请输入政策类别" v-model="searchData.policyCategoryName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span='4'>
                            <el-button type='primary' @click='getList'
                                >查询
                            </el-button>
                        </el-col>
                         <el-col :span='4'>
                            <el-button type='primary' @click='getShow'
                                >刷新
                            </el-button>
                        </el-col>
                       </el-row>
                    </el-form>
                 <el-button
                    type="success"
                    class="button"
                    size="mini"
                    @click="handletypeForm('新增', 'add')"
                    >新增</el-button
                >
                <div class="box">
                    <el-table
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%; margin: 15px 0"
                        border
                        ref="multipleTable"
                        height="250"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="index"
                            width="50"
                            label="序号"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="policyCategoryName"
                            label="政策类别"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center"
                            width="200px"
                            fixed="right"
                        >
                            <template slot-scope="scope">
                                <span
                                    @click="handletypeForm('编辑',scope.row)"
                                    style="margin-right: 12px; cursor: pointer"
                                    >编辑</span
                                >
                                <span
                                    @click="deleteItem(scope.row)"
                                    style="margin-right: 12px; cursor: pointer"
                                    >删除</span
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        align="center"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :current-page.sync="pageNo"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handletableDataSize"
                        @current-change="handleTableDataChange"
                    ></el-pagination>
                </div>
            </div>
            <div class="footer">
                <el-button type="primary" @click="save" :loading="saveLoading"
                    >确 定</el-button
                >
                <el-button @click="dialogClose">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="title"
            :visible.sync="typeState"
            :close-on-click-modal="false"
            width="400px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="
                        title == '查看'
                    "
                    label-position="left"
                    label-width="100px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="政策类别:" prop="policyCategoryName">
                        <el-input
                            v-model.trim="formData.policyCategoryName"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="title != '查看'"
            >
                <el-button type="primary" @click="handleSubmit('formData')"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone('formData')">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            saveLoading: false,
            searchLoading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            chooseIds: [],
            tableData: [],
            formData:{
                policyCategoryName:'' 
            },
            searchData:{},
            name: "",
            phone: "",
            isSearchContent: true,
            typeState:false,
            title:'',
            formDataRules: {
                policyCategoryName: [
                    { required: true, message: '请输入政策类别', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        this.getList()
        this.chooseIds = []
    },

    methods: {
        handletypeForm(title,row){
             this.title=title;
             this.typeState=true;
             if(title=='编辑'){
                   this.formData.policyCategoryName=row.policyCategoryName
             }
            let id=''
            this.id=row.id
        },
         dialogVisibleClone(formName) {
            this.typeState=false;
            this.formData.policyCategoryName=""
        },
        handleSubmit(formName){
            let ff=false;
            for(let i in this.tableData){
                   if(this.tableData[i].policyCategoryName==this.formData.policyCategoryName){
                            let ff=true;
                            this.$message('该数据已存在，请重新输入')
                            return
                   }
            }
            if(!ff){
                 this.$refs[formName].validate((valid) => {
                 if (valid) {
                     if(this.title=='新增'){
                          this.$http.request({
                            url: '/ypt/admin/BenefitsTheElderly/info/save',
                            method: 'POST',
                            data: {
                            pageNo:1,
                            pageSize: 99,
                            policyCategoryName:this.formData.policyCategoryName,
                            }
                            }).then(res => {
                                if(res.code == 200) {
                                     this.typeState=false;
                                   this.getList()
                                     return
                                }
                                this.$message({
                                    message: '新增失败',
                                    type: 'error'
                                })
                            })
                        }
                    if(this.title=='编辑'){
                           this.$http.request({
                            url: '/ypt/admin/BenefitsTheElderly/info/update',
                            method: 'POST',
                            data: {
                               id: this.id,
                               ...this.formData
                            }
                        }).then(res => {
                            if(res.code == 200) {
                                this.getList()
                                this.typeState=false;
                                return
                            }
                            this.$message({
                                message: '根据ID获取信息失败',
                                type: 'error'
                            })
                        })
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
             });
            }
        },
        //刷新
       getShow(){
           this.searchData.policyCategoryName=''
            this.getList()
       },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/BenefitsTheElderly/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 搜搜
        searchList() {
            this.getList()
        },
        // 人员选择
        handleSelectionChange(rows) {
            if (rows) {
                rows.forEach((row, index) => {
                    this.chooseIds.push(row.id)
                })
            }
        },
        // 获取表格数据
        getList() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                policyCategoryName:this.searchData.policyCategoryName,
            }
            this.$http
                .request({
                    url: "/ypt/admin/BenefitsTheElderly/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        // 页面大小
        handletableDataSize(val) {
            this.pageSize = val
            this.getList()
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageNo = val
            this.getList()
        },
        // 清空
        clearData() {
            this.pageSize = 10
            this.pageNo = 1
            this.total = 0
            this.name = ""
            this.phone = ""
            this.tableData = []
            this.chooseIds = []
            this.$refs.multipleTable.clearSelection()
            this.getList()
        },
        // 保存信息
        save() {
            this.$http.request({
				url: "/ypt/admin/careOldPolicyCategory/info/save",
				method: "POST",
				data: {
					...this.formData,
				},
			}).then((res) => {
				if (res.code == 200) {
					this.getList();
				}
			})
            this.formData={}
        },
        // 关闭人员信息
        dialogClose() {
            this.openData.state = false
            this.clearData()
            this.$emit("canclePerson", false)
        },
    },
}
</script>
<style lang="less" scoped>
// .content {
//    border-top: 1px solid #eee;
//} 
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    .search_head {
        background: #e6e6e6;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 42px 20px 20px 20px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown1 {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
    .el-icon-arrow-up {
        &::before {
            color: #000;
            font-size: 18px;
        }
    }
}
.box {
    margin: 25px 0;
}
</style>